import { render, staticRenderFns } from "./passwordChangePage.vue?vue&type=template&id=2ee90c36"
import script from "./passwordChangePage.vue?vue&type=script&lang=js"
export * from "./passwordChangePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports